<template>
  <!-- 材料管理编辑 -->
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
     width="1000px"
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('unmspace:cecUnmMaterialScheme:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="100px">
      <el-row  :gutter="15">
        <el-col :span="24">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="所属项目" prop="project.id"
                :rules="[
                  {required: true, message:'所属项目不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            title="选择所属项目"
            labelName = 'nameEn'
            labelValue = 'id'
            :value = "inputForm.project.id"
            :limit="10"
            @getValue='(value) => {inputForm.project.id=value}'
            :columns="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmProject/list"
            queryEntityUrl="/unmspace/cecUnmProject/queryById">
          </GridSelect>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="关联材料" prop="project.id"
                :rules="[
                  {required: true, message:'关联材料不能为空', trigger:'blur'}
                 ]">
          <NothingSelect
            title="选择关联材料"
            labelName = 'nameEn'
            labelValue = 'id'
            :value = "materialId"
            :limit="10"
            showType="table"
            @getValue='receiveGridSelect'
            :columns="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmItem/list"
            queryEntityUrl="/unmspace/cecUnmItem/queryById">
          </NothingSelect>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="ml16" style="min-height: 40px;">
            <el-table
              :data="marterialTableList"
              border
              style="width: 100%">
              <el-table-column
                label="序号"
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                prop="type"
                align="center"
                label="材料使用"
                width="180">
                <template #default="scope">
                    <el-select
                      v-model="scope.row.type"
                      class="m-2"
                      placeholder="请选择材料类型"
                      style="width: 150px"
                      @change="handSelect(scope.row)"
                    >
                      <el-option
                        v-for="item in selectList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
              </el-table-column>
              <el-table-column
                prop="code"
                align="center"
                label="编码"
                width="180">
              </el-table-column>
              <el-table-column
                prop="nameCn"
                align="center"
                label="中文名称">
              </el-table-column>
              <el-table-column
                prop="unit"
                align="center"
                label="单位">
              </el-table-column>
              <el-table-column
                prop="price"
                align="center"
                label="单价">
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button @click="handDelete(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import GridSelect from '@/components/gridSelect'
  import NothingSelect from '@/components/gridSelect/nothing.vue'
  import cecUnmMaterialSchemeService from '@/api/unmspace/cecUnmMaterialSchemeService'
  import cecUnmMaterialSchemeItemService from '@/api/unmmaterialschemeitem/cecUnmMaterialSchemeItemService'
  import cecUnmItemService from '@/api/unmspace/cecUnmItemService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          project: {
            id: ''
          }
        },
        firstMaterialId: '',
        materialId: '',
        materialList: [],
        marterialTableList: [],
        selectList: [
          {value: '1', label: '主材料'},
          {value: '2', label: '辅材料'},
          {value: '3', label: '替代主材料'}
        ]
      }
    },
    components: {
      GridSelect,
      NothingSelect
    },
    watch: {
      visible: {
        handler (newVal) {
          if (newVal) {
            this.marterialTableList = []
            this.selectList = [
              {value: '1', label: '主材料'},
              {value: '2', label: '辅材料'},
              {value: '3', label: '替代主材料'}
            ]
            this.getMaterialList()
          }
        },
        immediate: false,
        deep: true
      },
      materialList: {
        handler (newVal) {
          this.$nextTick(() => {
            console.log(newVal)
            newVal.forEach(element => {
              this.marterialTableList = []
              // 获取材料具体内容
              cecUnmItemService.queryById(element.itemId).then(({data}) => {
                let recoverType = {
                  // itemId: id,
                  code: '',
                  nameCn: '',
                  price: '',
                  unit: ''
                }
                let backData = this.recover(recoverType, data)
                let mergeData = {...element, ...backData}
                this.marterialTableList.push(mergeData)
              })
            })
          })
        },
        immediate: false,
        deep: true
      }
    },
    methods: {
      // 材料使用
      handSelect (e) {
        let filterList = this.marterialTableList.filter(item => item.type === '1')
        if (filterList.length === 2) {
          this.$message.error('主材只能选择一个')
          e.type = ''
        }
        // if (filterList.length >= 2) {
        //   this.selectList = [
        //     {value: '2', label: '辅材料'},
        //     {value: '3', label: '替代主材料'}
        //   ]
        // } else {
        //   this.selectList = [
        //     {value: '1', label: '主材料'},
        //     {value: '2', label: '辅材料'},
        //     {value: '3', label: '替代主材料'}
        //   ]
        // }
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      // 选择材料后更新表格数据
      receiveGridSelect (value) {
        if (Object.keys(value).length === 0) {
          this.materialLis = []
          this.marterialTableList = []
          this.materialId = ''
          return
        }
        this.materialList = value.map(item => {
          let findArray = this.marterialTableList.find(eitem => eitem.itemId === item.id)
          return {
            code: item.code,
            itemId: item.id,
            materialSchemeId: this.inputForm.id,
            nameCn: item.nameCn,
            price: item.price,
            unit: item.unit,
            type: findArray ? findArray.type : '',
            id: findArray ? findArray.id : ''
          }
        })
        this.materialId = value.map(item => item.id).join(',')
      },
      // 获取材料方案关联材料内容
      getMaterialList () {
        cecUnmMaterialSchemeItemService.list({
          'current': '1',
          'size': 1000
        }).then(({data}) => {
          let res = data.records
          this.materialList = res.filter(item => item.materialSchemeId === this.inputForm.id).map(mitem => {
            return {
              id: mitem.id,
              itemId: mitem.itemId,
              materialSchemeId: mitem.materialSchemeId,
              type: mitem.type
            }
          })
          this.materialId = this.materialList.map(item => item.itemId).join(',')
          this.firstMaterialId = res.filter(item => item.materialSchemeId === this.inputForm.id).map(mitem => mitem.id).join(',')
        })
      },
      // 删除行
      handDelete (tag) {
        this.marterialTableList.splice(this.marterialTableList.indexOf(tag), 1)
        this.materialId = this.marterialTableList.filter(item => item.code !== tag.code).map(mitem => mitem.itemId).join(',')
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建材料方案管理`
        } else if (method === 'edit') {
          this.title = '修改材料方案管理'
        } else if (method === 'view') {
          this.title = '查看材料方案管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmMaterialSchemeService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      async doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (this.marterialTableList.length > 0 && this.marterialTableList.every(item => item.type === '')) {
            this.$message.error('关联材料类型不能为空')
            return
          }
          if (valid) {
            this.loading = true
            this.marterialTableList.forEach(item => {
              let query = {
                id: item.id,
                materialSchemeId: item.materialSchemeId,
                itemId: item.itemId,
                type: item.type
              }
              cecUnmMaterialSchemeItemService.save(query).then(({data}) => {}).catch(() => {
                this.loading = false
                this.$message.error('请求异常')
              })
            })
            this.deleteSchemeItem()
            this.updateMaterialSc()
          }
        })
      },
      // 删除之前关联的材料
      deleteSchemeItem () {
        let nowSchemeItemIds = this.marterialTableList.map(item => item.id)
        let firstIds = this.firstMaterialId.split(',')
        let deleteIds = []
        firstIds.forEach(item => {
          if (!nowSchemeItemIds.includes(item)) {
            deleteIds.push(item)
          }
        })
        cecUnmMaterialSchemeItemService.delete(deleteIds.join(',')).then(({data}) => {}).catch(() => {
          this.loading = false
          this.$message.error('请求异常')
        })
      },
      // 更新材料方案
      updateMaterialSc () {
        cecUnmMaterialSchemeService.save(this.inputForm).then(({data}) => {
          this.visible = false
          this.$message.success(data)
          this.$emit('refreshDataList')
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
</script>
<style scoped>
 ::v-deep .el-dialog__body{
  padding: 10px 20px !important;
}
</style>
  
